import type { SearchResult } from '../types';

export interface TaxonomyItem {
  weight: string;
  tid: string;
  name: string;
  parent_tid: string;
  parent_term: string | null;
}

export function mungeSearchResult(result: $AnyFixMe): SearchResult {
  return {
    ...result,
    ds_created: new Date(result.ds_created),
    ds_updated: new Date(result.ds_updated),
    its_nid: result.its_nid.toString()
  };
}

export function mungeTaxonomy(
  items: TaxonomyItem[]
): { id: string; name: string }[] {
  // sort by display weight
  return items.map(item => ({
    name: item.name,
    id: item.tid
  }));
}
